import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gov-notify-service-configuration" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "field" }

import Toast from '@/shared/services/toast';
import { GovNotifyServiceViewModel } from '../models/govNotifyServiceViewModel';
import { govNotifyApi } from '../services/govNotifyApi';
import { useStore } from 'vuex';
import { computed, PropType, ref, watch } from 'vue';
import GovNotifyServiceConfigurationRow from '@/features/apps/govuknotifysms/components/GovNotifyServiceConfigurationRow.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GovNotifyServiceConfiguration',
  props: {
  value: {
    type: Array as PropType<GovNotifyServiceViewModel[]>,
    required: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["input"],
  setup(__props, { emit: __emit }) {

const serviceDataTableColumns = [
  { name: 'name', display: 'Name' },
  { name: 'phoneNumber', display: 'Phone Number' },
  { name: 'notifyApiKey', display: 'API Key' },
  { name: 'templateName', display: 'Template' },
  { name: 'bearerToken', display: 'Bearer Token' },
];
const messageCallbackUrl = govNotifyApi.getMessageWebhookUrl();
const deliveryCallbackUrl = govNotifyApi.getDeliveryWebhookUrl();

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);
const props = __props;

const emit = __emit;

const loadingToken = ref(false);
const serviceData = ref<Array<Partial<GovNotifyServiceViewModel>>>([]);
const serviceToDelete = ref<GovNotifyServiceViewModel | null>();
const hasInitialised = computed(() => props.value && props.value.length > 0);

watch(
  () => props.value,
  () => {
    serviceData.value = props.value || [];
    try {
      if (props.value.length === 0 && !props.loading && !hasInitialised.value) {
        addEmptyRow();
      }
    } catch (e: any) {
      console.error('Error setting initial row', e);
    }
  },
  { immediate: true },
);

async function addEmptyRow() {
  loadingToken.value = true;
  try {
    const newService = {
      id: '',
      bearerToken: 'Loading...',
      notifyApiKey: '',
      name: '',
      phoneNumber: '',
      isDraft: true,
    };
    serviceData.value.push(newService);

    const { bearerToken } = await govNotifyApi.getBearerToken(currentWorkspace.value.id);

    newService.bearerToken = bearerToken;
    newService.id = getServiceIdFromBearerToken(bearerToken);
    if (!newService.id) {
      Toast.showError('No service ID in the bearer token');
    }

    emit('input', serviceData.value);
  } catch (err: any) {
    Toast.showError('Failed to add service for configuration: ' + err.message);
  }
  loadingToken.value = false;
}

function onRowUpdate(updatedRow: Partial<GovNotifyServiceViewModel>) {
  const serviceId = updatedRow.id;
  if (!updatedRow.id) {
    return;
  }
  const index = serviceData.value.findIndex((row: Partial<GovNotifyServiceViewModel>) => row.id === serviceId);
  if (index !== -1) {
    serviceData.value[index] = updatedRow;
    serviceData.value = [...serviceData.value];
    emit('input', serviceData.value);
  }
}

function onCopy() {
  Toast.showInfo('Copied to clipboard');
}

function handleDeleteClick(row: GovNotifyServiceViewModel) {
  serviceToDelete.value = row;
  deleteService();
}

function deleteService() {
  if (serviceToDelete.value) {
    serviceData.value = serviceData.value.filter((service) => service !== serviceToDelete.value);
    emit('input', serviceData.value);
  }
}

function getServiceIdFromBearerToken(bearerToken: string) {
  const claims = JSON.parse(atob(bearerToken.split('.')[1]));
  return claims.serviceId;
}

return (_ctx: any,_cache: any) => {
  const _component_n_data_table = _resolveComponent("n-data-table")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_readonly_input = _resolveComponent("n-readonly-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", null, [
      _cache[1] || (_cache[1] = _createElementVNode("h3", null, "Configure Your Services", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "subtitle" }, "Copy the information from Gov.UK Notify", -1)),
      _createVNode(_component_n_data_table, {
        columns: serviceDataTableColumns,
        items: serviceData.value,
        loading: __props.loading
      }, _createSlots({ _: 2 }, [
        _renderList(['name', 'phoneNumber', 'notifyApiKey', 'templateName', 'bearerToken', 'actions'], (slot) => {
          return {
            name: slot,
            fn: _withCtx((slotProps) => [
              _createVNode(GovNotifyServiceConfigurationRow, {
                modelValue: slotProps.row,
                "onUpdate:modelValue": [($event: any) => ((slotProps.row) = $event), onRowUpdate],
                "workspace-id": currentWorkspace.value.id,
                column: slot,
                onDelete: handleDeleteClick,
                onCopy: onCopy
              }, null, 8, ["modelValue", "onUpdate:modelValue", "workspace-id", "column"])
            ])
          }
        })
      ]), 1032, ["items", "loading"]),
      _createVNode(_component_n_button, {
        variant: "ghost",
        onClick: addEmptyRow,
        icon: "add",
        id: "add-service"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Add Service")
        ])),
        _: 1
      })
    ]),
    _createElementVNode("section", null, [
      _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Configure Gov.UK Notify Callbacks", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "subtitle" }, "Complete your setup in Gov.UK Notify", -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_n_readonly_input, {
          value: _unref(deliveryCallbackUrl),
          label: "Delivery Receipts Callback URL",
          onCopy: onCopy
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_n_readonly_input, {
          value: _unref(messageCallbackUrl),
          label: "Received Messages Callback URL: ",
          onCopy: onCopy
        }, null, 8, ["value"])
      ])
    ])
  ]))
}
}

})